(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    // Trailing-edge window for stepper taps. Nothing the buyer can see is held
  // back by it - paintIntent() has already put the new number on screen - so
  // this only delays the confirmation. Long enough that a burst of taps costs
  // one request instead of one sequential round trip per tap.
  const COALESCE_MS = 250;

  // ...and a ceiling, measured from the first tap of a burst, so someone
  // leaning on + still reaches the server about once a second rather than
  // never.
  const COALESCE_MAX_MS = 900;

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      // What each line has been ASKED to become, per line key, while a request
      // for it is in flight or still inside the coalescing window. The stepper
      // used to count from the markup, and the markup is a render behind: two
      // quick taps on + both read 1 and both posted 2, so one of the two taps
      // was silently dropped. Intent lives here until the server's answer has
      // been rendered.
      this.pendingQuantities = new Map();

      // Per line key, the timer that will carry that line's latest intent.
      this.pendingTimers = new Map();

      // One mutation at a time. Every answer re-renders the whole cart, so two
      // in flight means the slower answer paints over the newer one and the
      // cart shows a quantity nobody asked for.
      this.mutations = Promise.resolve();

      // Per line key, the markup the SERVER last sent for that row. The
      // reconciler diffs incoming rows against this and never against the live
      // node, because the live node carries the optimistic edits below and so
      // would never compare equal to anything.
      this.serverRows = new Map();
      this.captureServerRows(this.list);

      // Rows taken out of the list by a removal that the server has not
      // confirmed yet, with the key of the row they sat in front of. Kept, not
      // discarded, so a failed removal has the row itself to put back.
      this.removedRows = new Map();

      this.addEventListener('click', (event) => this.handleClick(event));
      this.addEventListener('change', (event) => this.handleChange(event));
      document.addEventListener('submit', (event) => this.handleFormSubmit(event));

      // Leaving the page through the coalescing window would take unsent
      // intent with it.
      window.addEventListener('pagehide', () => this.flushOnUnload());
    }

    get dialog() {
      return this.querySelector('dialog');
    }

    get heading() {
      return this.dialog?.querySelector('.cart-drawer__heading');
    }

    // The empty state or the form - see snippets/cart-drawer-body.liquid.
    get body() {
      return this.dialog?.querySelector('[data-cart-body]');
    }

    get list() {
      return this.dialog?.querySelector('.cart-items');
    }

    // find() rather than a selector: line keys hold a colon.
    rowFor(key) {
      const list = this.list;
      if (!list) return null;
      return [...list.children].find((row) => row.dataset.cartLine === key) ?? null;
    }

    // The line's current quantity as far as the buyer is concerned: what the
    // last tap asked for if an answer is still outstanding, otherwise what the
    // markup says.
    quantityFor(key) {
      if (this.pendingQuantities.has(key)) return this.pendingQuantities.get(key);
      const input = this.rowFor(key)?.querySelector('[data-cart-quantity]');
      return Number(input?.value ?? 0);
    }

    // showModal() focuses the first focusable descendant, the close button,
    // and WebKit paints a ring on that script focus. Land on the heading
    // instead: the drawer's name is announced and the close button is one
    // Tab away. The same landing the data-slot sheets use (src/main.ts).
    open() {
      this.dialog.showModal();
      this.heading?.focus({ preventScroll: true });
      // Announced rather than called: an inline theme JavaScript block
      // cannot import from src/, so the empty state's recently-viewed
      // hydration (src/recently-viewed.ts, booted from src/main.ts) listens
      // for this instead - the same bridge the confirmation bubble uses. It
      // waits for the open because it costs a fetch per stored handle, and
      // most page views never open the cart at all.
      document.dispatchEvent(new CustomEvent('cart:opened'));
    }

    handleClick(event) {
      if (event.target.closest('[data-cart-open]')) {
        this.open();
        return;
      }

      if (event.target.closest('[data-cart-close]') || event.target === this.dialog) {
        this.dialog.close();
        return;
      }

      const removeButton = event.target.closest('[data-cart-remove]');
      if (removeButton) {
        this.updateLine(removeButton.dataset.cartRemove, 0);
        return;
      }

      const decreaseButton = event.target.closest('[data-cart-quantity-decrease]');
      if (decreaseButton) {
        const key = decreaseButton.dataset.cartQuantityDecrease;
        this.updateLine(key, Math.max(0, this.quantityFor(key) - 1));
        return;
      }

      const increaseButton = event.target.closest('[data-cart-quantity-increase]');
      if (increaseButton) {
        const key = increaseButton.dataset.cartQuantityIncrease;
        this.updateLine(key, this.quantityFor(key) + 1);
      }
    }

    handleChange(event) {
      const input = event.target.closest('[data-cart-quantity]');
      if (!input) return;

      const key = input.dataset.cartQuantity;
      const wanted = Number(input.value);

      // An emptied field reads as Number('') === 0, which would silently
      // delete the line the buyer was only editing. Anything that is not a
      // non-negative number puts the last known quantity back and asks for
      // nothing. getAttribute('value') is the server's number: the property
      // has been written by paintIntent, the attribute never is.
      if (input.value.trim() === '' || !Number.isFinite(wanted) || wanted < 0) {
        const last = this.pendingQuantities.get(key) ?? Number(input.getAttribute('value') ?? 0);
        input.value = String(last);
        return;
      }

      this.updateLine(key, wanted);
    }

    handleFormSubmit(event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      if (form.action.includes('/cart/add')) {
        event.preventDefault();
        this.addFromForm(form);
        return;
      }

      // The checkout gate. The checkout button submits the drawer's own form
      // as a plain navigation, and the coalescing window above is a period in
      // which the server has not been told what the buyer did - so leaving now
      // would check out a cart they have already changed. The hazard exists
      // without any coalescing at all, whenever a mutation is still in flight;
      // coalescing only widens it.
      if (form.id !== 'cart-drawer-form' || this.checkingOut) return;
      event.preventDefault();
      this.checkingOut = true;
      this.settled().then(() => {
        // requestSubmit, not submit(): submit() fires no submit event, and it
        // drops the submitter - and name="checkout" on that button is the
        // whole reason the POST redirects to checkout instead of back to the
        // cart. Re-found rather than reused, because the answer that just
        // landed may have replaced it.
        const checkout = form.querySelector('[name="checkout"]');
        form.requestSubmit(checkout ?? undefined);
      });
    }

    async addFromForm(form) {
      const formData = new FormData(form);

      // Adding no longer opens the drawer. The confirmation is the bubble
      // above, driven from src/main.ts - this block can't import from
      // data-slot/, so it signals with a document event instead.
      let response;
      try {
        response = await fetch(this.dataset.cartAddUrl, { method: 'POST', body: formData });
      } catch {
        this.announceCart('cart:add-failed');
        return;
      }

      // Previously a bare `return`. With the drawer no longer flying open,
      // silence here would be indistinguishable from success.
      if (!response.ok) {
        // Shopify answers a refused add with its own reason - "You can only
        // add 1 of X to the cart" when a variant has run out. Flattening that
        // to the theme's generic failure threw away the only sentence that
        // explained what had happened, which is what made an add the server
        // had already refused look like it had simply gone nowhere.
        let reason;
        try {
          const error = await response.json();
          if (typeof error?.description === 'string') reason = error.description;
        } catch {
          // Not JSON, or no body. The generic message stands.
        }
        this.announceCart('cart:add-failed', { reason });
        return;
      }

      const json = await response.json();

      // A multi-item JSON POST answers with {items:[...]}; a single-item form
      // POST answers with a bare line item at the root. Both shapes are live,
      // so read defensively rather than assuming one.
      const line = json.items?.[0] ?? json;
      // product_title, not title - `title` is "Product - Variant" with a
      // hyphen this theme never uses; cart-items.liquid renders the product
      // title alone. Prices are integer cents; src/main.ts formats them.
      //
      // final_price (per unit), NOT final_line_price. This is the one place we
      // deliberately diverge from cart-items.liquid: a cart row reports LINE
      // state, but a confirmation reports the action just taken. Adding a
      // second of something already in the cart returns the resulting line -
      // so final_line_price would announce a total the buyer did not just
      // spend. Safe to treat as "what was added" because the only /cart/add
      // form in the theme posts a hardcoded quantity of 1
      // (sections/product.liquid). If a quantity picker is ever added, this
      // becomes final_price x quantity AND the bubble has to show the
      // multiplier, or the number looks unexplained.
      //
      // Announced before the refresh, not after: the bubble is the receipt for
      // the tap, and should not wait on a second request.
      //
      this.announceCart('cart:added', {
        title: typeof line?.product_title === 'string' ? line.product_title : undefined,
        priceCents: typeof line?.final_price === 'number' ? line.final_price : undefined,
      });

      await this.refresh();
    }

    announceCart(type, detail) {
      document.dispatchEvent(new CustomEvent(type, { bubbles: true, detail }));
    }

    /* --- Intent --------------------------------------------------------- */

    // Records what the line has been asked to become, paints it at once, and
    // schedules the request. Returns the tail of the mutation queue, so a
    // caller can await the cart actually settling.
    updateLine(key, quantity) {
      const wanted = Number(quantity);
      if (!Number.isFinite(wanted) || wanted < 0) return this.mutations;

      this.pendingQuantities.set(key, wanted);
      this.paintIntent(key, wanted);

      // A removal is terminal - there is nothing a later tap could coalesce
      // with it - and it is a deliberate act, so it goes now.
      if (wanted === 0) return this.flushLine(key);

      this.scheduleFlush(key);
      return this.mutations;
    }

    scheduleFlush(key) {
      const existing = this.pendingTimers.get(key);
      const deadline = existing?.deadline ?? Date.now() + COALESCE_MAX_MS;
      if (existing) clearTimeout(existing.timer);
      const wait = Math.max(0, Math.min(COALESCE_MS, deadline - Date.now()));
      this.pendingTimers.set(key, {
        deadline,
        timer: setTimeout(() => this.flushLine(key), wait),
      });
    }

    // Moves a line's latest intent out of the window and onto the queue. The
    // debounce sits in FRONT of the queue; it does not replace it.
    flushLine(key) {
      const timer = this.pendingTimers.get(key);
      if (timer) {
        clearTimeout(timer.timer);
        this.pendingTimers.delete(key);
      }
      if (!this.pendingQuantities.has(key)) return this.mutations;

      const wanted = this.pendingQuantities.get(key);
      this.mutations = this.mutations
        .then(() => this.postLine(key, wanted))
        .catch((error) => {
          // The queue has to survive a rejection. A chain left rejected drops
          // every later tap without a word, which is a worse failure than the
          // one that caused it - and postLine only announces the two failures
          // it expects, so anything else would pass in silence.
          console.warn('Cart update failed', error);
          this.announceCart('cart:update-failed');
        });
      return this.mutations;
    }

    // Snapshotted, not iterated live: flushLine deletes the entry it just
    // sent, and a Map mutated mid-iteration skips entries.
    flushAll() {
      for (const key of [...this.pendingTimers.keys()]) this.flushLine(key);
    }

    // Every tap sent, every answer in. What the checkout gate waits on.
    async settled() {
      this.flushAll();
      await this.mutations;
    }

    // Fire-and-forget on the way out: no refresh and no queue, because there
    // will be no document left to paint into.
    flushOnUnload() {
      // Snapshotted for the same reason flushAll is: the loop deletes as it
      // goes.
      for (const [key, timer] of [...this.pendingTimers]) {
        clearTimeout(timer.timer);
        this.pendingTimers.delete(key);
        const quantity = this.pendingQuantities.get(key);
        if (quantity === undefined) continue;
        fetch(this.dataset.cartChangeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity }),
          keepalive: true,
        }).catch(() => {});
      }
    }

    /* --- Optimistic paint ----------------------------------------------- */

    // The number moves on the tap, not on the answer. The line price and the
    // subtotal deliberately do NOT: per-unit price is not derivable in this
    // cart - bundle lines are priced by the Cart Transform, there is a
    // separate fee line, and a sale line carries a compare-at pair - so a
    // computed total would be right for plain lines and wrong exactly where
    // this theme is unusual. They mark themselves as settling instead.
    paintIntent(key, wanted) {
      // Zero is not a quantity to paint, it is the row leaving.
      if (wanted === 0) {
        this.removeRow(key);
        return;
      }

      const row = this.rowFor(key);
      if (!row) return;

      const input = row.querySelector('[data-cart-quantity]');
      if (input) input.value = String(wanted);
      row.dataset.cartPending = '';
      this.markSettling();
    }

    clearPending(key) {
      const row = this.rowFor(key);
      if (row) delete row.dataset.cartPending;
      this.markSettling();
    }

    markSettling() {
      this.toggleAttribute('data-cart-settling', this.pendingQuantities.size > 0);
    }

    // A removed row leaves the list on the tap, not on the answer, and not
    // over a transition. The rows below it close up in the same frame - there
    // is nothing to watch, so there is nothing to wait for.
    //
    // The node is kept aside rather than discarded, which is what makes the
    // rollback free: a failed removal has the row itself to put back, in the
    // place it came from. Hiding it in place would have done that too, but a
    // `display: none` row still matches `.cart-items__row:last-child`, so
    // removing the last line would leave the new last line wearing a seam
    // rule and its padding until the server answered - the exact delayed
    // realignment this avoids.
    removeRow(key) {
      if (this.removedRows.has(key)) return;

      const row = this.rowFor(key);
      if (!row) return;

      // Focus leaves before the node does, or it falls out of the dialog.
      if (row.contains(document.activeElement)) this.heading?.focus({ preventScroll: true });

      this.removedRows.set(key, { row, before: row.nextElementSibling?.dataset.cartLine ?? null });
      row.remove();
    }

    // Back where it was: before whatever followed it, or at the end if it was
    // last. The neighbour may itself be gone by now, in which case the end of
    // the list is the honest answer and the next answer will re-order it.
    restoreRow(key) {
      const removed = this.removedRows.get(key);
      this.removedRows.delete(key);
      if (!removed) return;

      const list = this.list;
      if (!list) return;

      const before = removed.before ? this.rowFor(removed.before) : null;
      list.insertBefore(removed.row, before);
    }

    /* --- Requests ------------------------------------------------------- */

    async postLine(key, quantity) {
      try {
        // Failures must be loud. A silent bail here presents as "the cart is
        // stale until reload", indistinguishable from a rendering bug - e.g.
        // `theme dev` browsed via a LAN IP, where the insecure origin drops the
        // session cookie and every cart POST is rejected.
        let response;
        try {
          response = await fetch(this.dataset.cartChangeUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity }),
          });
        } catch {
          this.failLine(key);
          return;
        }
        if (!response.ok) {
          console.warn('Cart update rejected: ' + response.status);
          this.failLine(key);
          return;
        }

        await this.refresh();
      } finally {
        // Dropped only if no later tap has overtaken this one - that tap's
        // intent is the live one and has to outlive this answer. Dropped on
        // failure too: the markup holds the server's truth again, so the next
        // tap should count from it rather than from an intent that never
        // landed.
        if (this.pendingQuantities.get(key) === quantity) {
          this.pendingQuantities.delete(key);
          this.clearPending(key);
          // The node is only held for a rollback. Once this line has settled
          // there is nothing to roll back to, and holding it would make a key
          // the buyer re-added unreachable to the reconciler.
          this.removedRows.delete(key);
        }
      }
    }

    // The cart on its own, with no layout around it
    // (templates/cart.drawer.liquid). This replaced asking for the whole
    // header section - which is where the drawer is mounted, so the
    // navigation, the mega menus and the search drawer were all being
    // rendered server-side and thrown away to move one number by one.
    async refresh() {
      let response;
      try {
        response = await fetch(this.dataset.cartViewUrl, { cache: 'no-store' });
      } catch {
        this.announceCart('cart:update-failed');
        return;
      }
      if (!response.ok) {
        console.warn('Cart view rejected: ' + response.status);
        this.announceCart('cart:update-failed');
        return;
      }

      const html = await response.text();
      const next = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('[data-cart-fragment]');
      if (next) this.applyCart(next);

      // The cart has settled into something new. Anything on the page whose
      // own state depends on cart contents says so here - today the product
      // form, which may not offer a unit the buyer is already holding
      // (sections/product.liquid). Announced without a payload on purpose:
      // this fires for adds, quantity edits and removals alike, and a
      // listener that needs the numbers should count the cart rather than
      // trust a summary of one mutation.
      this.announceCart('cart:changed');
    }

    // The cross-repo front door (see the comment on the element above). The
    // StickBuilder app hands whole header-section markup to this after its own
    // /cart/add, so it has to keep taking that shape. It parses down to the
    // same two things the fragment carries, and hands them to the same
    // reconciler.
    render(sectionHtml, openAfter) {
      if (!sectionHtml) return;

      const next = new DOMParser().parseFromString(sectionHtml, 'text/html').getElementById(this.id);
      if (!next) return;

      this.applyCart(next);

      if (openAfter && this.dialog && !this.dialog.open) this.open();
    }

    /* --- Reconciling ---------------------------------------------------- */

    applyCart(next) {
      const count = this.querySelector('[data-cart-count]');
      const nextCount = next.querySelector('[data-cart-count]');
      if (count && nextCount) {
        count.textContent = nextCount.textContent;
        count.hidden = nextCount.hasAttribute('hidden');
      }

      const body = this.body;
      const nextBody = next.querySelector('[data-cart-body]');
      if (!body || !nextBody) return;

      // Empty and filled are two different bodies, not two states of one.
      // Crossing between them is the one case with nothing worth preserving -
      // and keeping a wholesale swap on that path is also what keeps ADR
      // 0033's "nothing may be bound inside the dialog" contract honest.
      if (body.dataset.cartBody !== nextBody.dataset.cartBody) {
        const focused = this.focusedControl();
        body.replaceWith(document.importNode(nextBody, true));
        this.captureServerRows(this.list);
        if (focused) this.restoreFocus(focused);
        return;
      }

      this.reconcileRows(nextBody.querySelector('.cart-items'));
      this.syncSummary(nextBody.querySelector('.cart-summary'));
      this.captureServerRows(nextBody.querySelector('.cart-items'));
    }

    // A keyed walk, not a swap. A row whose key and markup are both unchanged
    // is never touched - which is what keeps .cart-drawer__items, the drawer's
    // only scroller, alive across a mutation, and with it the scroll position,
    // the scroll timeline behind the top fade (ADR 0034), and every image that
    // has already been decoded.
    reconcileRows(nextList) {
      const list = this.list;
      if (!list || !nextList) return;

      const live = new Map();
      for (const row of list.children) {
        if (row.dataset.cartLine) live.set(row.dataset.cartLine, row);
      }

      const focused = this.focusedControl();
      let refocus = false;
      let anchor = null;

      for (const nextRow of nextList.children) {
        const key = nextRow.dataset.cartLine;
        if (!key) continue;

        // A line the buyer has already removed is out of the list, and this
        // answer predates that - it still has the row. Re-inserting it would
        // flash it back for the length of a round trip.
        if (this.removedRows.has(key)) continue;

        const current = live.get(key);
        live.delete(key);

        let node = current;
        if (!current) {
          node = document.importNode(nextRow, true);
        } else if (this.serverRows.get(key) !== nextRow.outerHTML) {
          node = document.importNode(nextRow, true);
          current.replaceWith(node);
          if (focused?.key === key) refocus = true;
        }

        const target = anchor ? anchor.nextElementSibling : list.firstElementChild;
        if (node !== target) list.insertBefore(node, target);
        anchor = node;
      }

      // Whatever the server no longer has.
      for (const row of live.values()) {
        if (row.contains(document.activeElement)) this.heading?.focus({ preventScroll: true });
        row.remove();
      }

      // Intent outlives the answer. A reply that landed while a later tap was
      // still inside the coalescing window carries the OLDER number, and the
      // replaced row would paint it - so the quantity would visibly count
      // backwards for as long as it takes the next request to correct it.
      // That is the same class of bug the intent map was introduced to kill,
      // and a wholesale swap used to hide it only by losing the row anyway.
      for (const [key, wanted] of this.pendingQuantities) this.paintIntent(key, wanted);

      if (refocus) this.restoreFocus(focused);
    }

    // Leaves only. The checkout button can hold focus and is the submitter the
    // gate above re-submits with; replacing it would drop both.
    syncSummary(nextSummary) {
      const summary = this.dialog?.querySelector('.cart-summary');
      if (!summary || !nextSummary) return;

      const total = summary.querySelector('.cart-summary__subtotal span:last-child');
      const nextTotal = nextSummary.querySelector('.cart-summary__subtotal span:last-child');
      if (total && nextTotal) total.textContent = nextTotal.textContent;

      const checkout = summary.querySelector('[name="checkout"]');
      const nextCheckout = nextSummary.querySelector('[name="checkout"]');
      if (checkout && nextCheckout) checkout.disabled = nextCheckout.disabled;
    }

    // Taken from the SERVER's markup, never from the live list, which by now
    // carries optimistic edits.
    captureServerRows(list) {
      this.serverRows.clear();
      if (!list) return;
      for (const row of list.children) {
        if (row.dataset.cartLine) this.serverRows.set(row.dataset.cartLine, row.outerHTML);
      }
    }

    // The optimistic number never landed, and leaving it on screen is a lie
    // the buyer would carry to checkout. Put the server's last word back.
    failLine(key) {
      this.announceCart('cart:update-failed');

      // A removal that never landed: the row is still in hand, so put it back
      // where it was rather than rebuilding it from a snapshot.
      if (this.removedRows.has(key)) {
        this.restoreRow(key);
        return;
      }

      const row = this.rowFor(key);
      if (!row) return;

      const html = this.serverRows.get(key);
      if (!html) {
        delete row.dataset.cartPending;
        return;
      }

      const restored = new DOMParser()
        .parseFromString('<ul>' + html + '</ul>', 'text/html')
        .querySelector('li');
      if (restored) row.replaceWith(document.importNode(restored, true));
    }

    /* --- Focus ---------------------------------------------------------- */

    // A row whose markup changed is replaced, and the row being stepped is
    // precisely the row whose markup changed - so focus still has to be
    // carried across that one node. Remember it as something that survives new
    // markup: the attribute naming the control and the line key it carries.
    focusedControl() {
      const active = document.activeElement;
      if (!this.dialog?.open || !active || !this.dialog.contains(active)) return null;
      const name = [
        'data-cart-remove',
        'data-cart-quantity',
        'data-cart-quantity-increase',
        'data-cart-quantity-decrease',
      ].find((attribute) => active.hasAttribute(attribute));
      return { name, key: name ? active.getAttribute(name) : null };
    }

    // Back on the same control of the same line. A removed line, or focus on
    // anything else, lands on the heading. find() rather than a selector:
    // line keys hold a colon.
    restoreFocus({ name, key }) {
      const target = name
        ? [...this.dialog.querySelectorAll('[' + name + ']')].find(
            (el) => el.getAttribute(name) === key,
          )
        : null;
      (target ?? this.heading)?.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.abortController = null;
      // Set per call site, because the collection and search sections wrap
      // their results in different elements.
      this.scopeSelector = this.dataset.scope;

      // The drawer portals its filter inputs to document.body, so a listener
      // on the form itself would miss their change events - listen on
      // document instead and match via the `form` IDL property, which still
      // resolves correctly across the portal thanks to each input's form=""
      // attribute.
      this.handleChange = (event) => {
        if (event.target.form !== this.form) return;
        this.form.requestSubmit();
      };
      document.addEventListener('change', this.handleChange);

      this.handleSubmit = (event) => {
        event.preventDefault();
        // Built from the form's own FormData, which is why anything that must
        // survive a filter change - notably search's `q` - has to be a hidden
        // input inside the form rather than merely present in the URL.
        const params = new URLSearchParams(new FormData(this.form));
        // The show button lives inside the drawer, so it's already portalled
        // out to document.body by the time it's clickable - match by class
        // rather than an element reference from `this`.
        const closeDrawer = Boolean(event.submitter?.classList.contains('main-collection__show-button'));
        this.applyFilters(`${this.form.action}?${params}`, { closeDrawer });
      };
      this.form.addEventListener('submit', this.handleSubmit);

      // Pagination links live outside this element - delegate on document
      // like the change listener above. Every instance on the page
      // registers its own listener, so the ownership check below matters:
      // without it, N instances would each try to handle the same click.
      this.handleDocumentClick = (event) => {
        // The drawer portals this link to document.body just like the show
        // button above, so - same as that button - it's matched by class
        // rather than DOM ownership. Routing it through applyFilters instead
        // of a real navigation keeps the drawer open and its scroll/open
        // state intact instead of reloading the whole page.
        const clearLink = event.target.closest('.collection-filter-drawer__clear');
        if (clearLink instanceof HTMLAnchorElement) {
          event.preventDefault();
          this.applyFilters(clearLink.href);
          return;
        }

        const link = event.target.closest('.pagination__link');
        // Pagination renders the current page and gaps as plain <span>s with
        // the same .pagination__link class, not real links - skip those.
        if (!(link instanceof HTMLAnchorElement)) return;

        const owner = link.closest(this.scopeSelector)?.querySelector('collection-filters');
        if (owner !== this) return;

        event.preventDefault();
        const isPagination = Boolean(link.closest('.pagination'));
        if (isPagination) this.scrollToBar();
        this.applyFilters(link.href, { focusResults: isPagination });
      };
      document.addEventListener('click', this.handleDocumentClick);

      this.handlePopState = () => {
        this.applyFilters(window.location.href, { pushState: false });
      };
      window.addEventListener('popstate', this.handlePopState);
    }

    disconnectedCallback() {
      if (this.handleChange) document.removeEventListener('change', this.handleChange);
      if (this.handleSubmit) this.form?.removeEventListener('submit', this.handleSubmit);
      if (this.handleDocumentClick) document.removeEventListener('click', this.handleDocumentClick);
      if (this.handlePopState) window.removeEventListener('popstate', this.handlePopState);
    }

    async applyFilters(url, { closeDrawer = false, focusResults = false, pushState = true } = {}) {
      this.abortController?.abort();
      const controller = new AbortController();
      this.abortController = controller;

      this.setAttribute('aria-busy', 'true');

      const fetchUrl = new URL(url, window.location.href);
      fetchUrl.searchParams.set('section_id', this.dataset.sectionId);

      let html;
      try {
        const response = await fetch(fetchUrl, { signal: controller.signal });
        if (!response.ok) throw new Error('facets: failed to fetch filtered results');
        html = await response.text();
      } catch (error) {
        if (error.name === 'AbortError') return;
        // Network hiccup or bad response - fall back to a real navigation
        // rather than leaving the UI stuck.
        window.location.href = url;
        return;
      }

      this.graft(new DOMParser().parseFromString(html, 'text/html'));

      if (pushState) {
        const visibleUrl = new URL(url, window.location.href);
        visibleUrl.searchParams.delete('section_id');
        history.pushState({}, '', visibleUrl);
      }

      if (closeDrawer) {
        document
          .getElementById('filter-drawer')
          ?.dispatchEvent(new CustomEvent('dialog:set', { detail: { open: false } }));
      }

      if (focusResults) {
        const results = this.closest(this.scopeSelector)?.querySelector(
          '.main-collection__grid, .main-collection__empty',
        );
        if (results) {
          results.setAttribute('tabindex', '-1');
          // scrollToBar() already moved the page; a scrolling focus() here
          // would cut its smooth scroll short wherever it happened to be.
          results.focus({ preventScroll: true });
        }
      }

      this.removeAttribute('aria-busy');
    }

    // A new page replaces the grid in place, so a shopper who paged from the
    // bottom would otherwise be left looking at the end of the new page.
    // Scrolls on the click rather than after the fetch, so the response is
    // immediate and the dimmed grid is what's on screen while it loads - the
    // bar sits above the grid, so swapping the grid in mid-scroll doesn't move
    // the target. Only when the bar is above the viewport: a short page whose
    // bar is still visible stays put.
    scrollToBar() {
      const offset = parseFloat(getComputedStyle(this).scrollMarginTop) || 0;
      if (this.getBoundingClientRect().top >= offset) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'instant' : 'smooth' });
    }

    // Grafts fetched markup into the live DOM instead of replacing whole
    // subtrees, so stateful nodes survive an update: the <form> element
    // (so the drawer inputs' form="" associations stay valid) and the
    // drawer's dialog root (so an open drawer doesn't snap shut and replay
    // its entrance transition on every filter change) are never replaced,
    // only their contents.
    graft(doc) {
      const scope = this.closest(this.scopeSelector);
      if (!scope) return;

      const oldResult = scope.querySelector('.main-collection__grid, .main-collection__empty');
      const newResult = doc.querySelector('.main-collection__grid, .main-collection__empty');
      if (oldResult && newResult) oldResult.replaceWith(newResult);

      const oldPagination = scope.querySelector('.pagination');
      const newPagination = doc.querySelector('.pagination');
      if (oldPagination && newPagination) {
        oldPagination.replaceWith(newPagination);
      } else if (oldPagination && !newPagination) {
        oldPagination.remove();
      } else if (!oldPagination && newPagination && newResult) {
        newResult.after(newPagination);
      }

      // Search renders a list of page/article hits above the grid; collections
      // never have one, so every combination here is optional. Filtering can
      // add or remove it between renders, hence all four cases.
      //
      // Matched on --pages specifically, not on .results-group: the collections
      // group sits directly above it with the same base class, and is populated
      // from a different endpoint entirely (see search-collections.liquid). A
      // bare .results-group lookup would find that one first and overwrite it.
      const oldSecondary = scope.querySelector('.results-group--pages');
      const newSecondary = doc.querySelector('.results-group--pages');
      if (oldSecondary && newSecondary) {
        oldSecondary.replaceWith(newSecondary);
      } else if (oldSecondary && !newSecondary) {
        oldSecondary.remove();
      } else if (!oldSecondary && newSecondary) {
        // Anchored on this toolbar rather than on the grid: search renders the
        // group immediately above the toolbar, and appending to the end of the
        // scope would drop it under the pagination.
        this.before(newSecondary);
      }

      const toolbarActions = this.querySelector('.main-collection__toolbar-actions');
      const newToolbarActions = doc.querySelector('.main-collection__toolbar-actions');

      const oldCount = toolbarActions?.querySelector('.main-collection__product-count');
      const newCount = newToolbarActions?.querySelector('.main-collection__product-count');
      if (oldCount && newCount) oldCount.textContent = newCount.textContent;

      // The sort control and show button now live inside the drawer body,
      // so they're covered by the innerHTML swap below - once the drawer's
      // been opened, the portal has moved that body to document.body,
      // detached from any element under the scope, so it's looked up by its
      // own stable id instead.
      const drawerBody = document.getElementById('filter-drawer-body');
      const newDrawerBody = doc.querySelector('.drawer__body');
      if (drawerBody && newDrawerBody) {
        const openItem = drawerBody.querySelector('[data-slot="accordion-item"][data-state="open"]');
        const openValue = openItem?.getAttribute('data-value');

        // Re-initializing the accordion below does a forced layout read (to
        // measure panel heights) while some triggers still sit in their
        // freshly-inserted, pre-hydration DOM state - that read flushes the
        // chevron's default rotation, and every filter pill's default
        // (unpressed) appearance, as a real "before" style. Hydrating the
        // toggle-groups afterward then sets data-state="on" on already-active
        // pills, which reads to the browser as a genuine change and plays
        // the transition again, even though nothing was actually toggled by
        // the user. Suppressing the transition for one frame avoids that
        // replay without touching the shared accordion/toggle-group
        // libraries.
        drawerBody.setAttribute('data-suppress-icon-transition', '');

        drawerBody.innerHTML = newDrawerBody.innerHTML;

        // The accordion is a data-slot component, not a custom element, so
        // it doesn't auto-upgrade when its markup is swapped in via
        // innerHTML - ask src/main.ts to bind a fresh controller on it. The
        // rendered markup always hardcodes data-default-value="filter-0", so
        // without the override below createAccordion() would initialize open
        // on that group and then immediately animate closed/open again to
        // reach whichever group the user actually had open - a visible
        // flicker. Setting data-default-value before hydrating instead makes
        // it initialize straight into the right state, with no correction
        // (and no animation) needed afterward.
        const accordionRoot = drawerBody.querySelector('[data-slot="accordion"]');
        if (accordionRoot) {
          if (openValue) {
            accordionRoot.setAttribute('data-default-value', openValue);
          }
          accordionRoot.dispatchEvent(new CustomEvent('data-slot:hydrate', { bubbles: true }));
        }

        // The sort control is also a data-slot component (radio-group), so
        // it needs the same re-hydration after the innerHTML swap above.
        const sortRoot = drawerBody.querySelector('.main-collection__sort');
        if (sortRoot) {
          sortRoot.dispatchEvent(new CustomEvent('data-slot:hydrate', { bubbles: true }));
        }

        // Same story for the price-range slider.
        const priceSliderRoot = drawerBody.querySelector('.collection-filter-drawer__price-slider');
        if (priceSliderRoot) {
          priceSliderRoot.dispatchEvent(new CustomEvent('data-slot:hydrate', { bubbles: true }));
        }

        // Each checkbox-style filter is its own toggle-group instance - same story.
        drawerBody
          .querySelectorAll('.collection-filter-drawer__panel--list[data-slot="toggle-group"]')
          .forEach((root) => root.dispatchEvent(new CustomEvent('data-slot:hydrate', { bubbles: true })));

        // Wait a frame past the layout reads above before re-enabling the
        // transition, so a genuine later click still animates normally.
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            drawerBody.removeAttribute('data-suppress-icon-transition');
          });
        });
      }
    }
  }

  if (!customElements.get('collection-filters')) {
    customElements.define('collection-filters', CollectionFilters);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["focus-modality"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;

    const set = (modality) => {
      if (root.dataset.inputModality !== modality) root.dataset.inputModality = modality;
    };

    document.addEventListener(
      'keydown',
      (event) => {
        if (event.metaKey || event.ctrlKey || event.altKey) return;
        set('keyboard');
      },
      true,
    );
    document.addEventListener('pointerdown', () => set('pointer'), true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-color-swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('.product-color-swatches__thumbnail');
    if (!thumbnail || thumbnail.classList.contains('product-color-swatches__thumbnail--active')) return;

    event.preventDefault();
    window.location.replace(thumbnail.href);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    // Travel before a press becomes a drag, so a click still opens the lightbox.
    const DRAG_SLOP_PX = 6;
    // Release speed (px/ms) past which the drag pages on in its direction.
    const FLICK_PX_PER_MS = 0.3;
    // A release this long after the last move has no velocity left.
    const FLICK_WINDOW_MS = 80;
    // How long to wait for `scrollend` where it is not supported.
    const SETTLE_FALLBACK_MS = 600;

    const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Drag-to-scroll for a mouse, with the release landing on a slide - the
    // app's gallery's (storefront/src/block/gallery.ts). Mouse only: a finger
    // and a trackpad already scroll the strip natively, and a second handler
    // would fight the browser's momentum. A mouse wheel cannot scroll
    // sideways, and with the arrows gone a narrow desktop window had no way
    // through the pictures but the keyboard.
    //
    // The drag writes scrollLeft 1:1 with snapping off (data-dragging), then
    // pages with a smooth scroll to the nearest slide - or on to the next if
    // the release was a flick - and turns snapping back on at scrollend, on
    // the snap point, so turning it back on moves nothing. A drag swallows the
    // click it ends in, so it never opens the lightbox.
    function mouseDrag(track) {
      let press = null;
      let dragging = false;
      let swallow = false;
      let samples = [];
      let settleTimer = 0;

      const endSettle = () => {
        window.clearTimeout(settleTimer);
        settleTimer = 0;
        track.removeEventListener('scrollend', endSettle);
        track.removeAttribute('data-dragging');
      };

      const onDown = (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        // Nothing to drag: one picture, or the desktop stack.
        if (track.scrollWidth - track.clientWidth <= 1) return;
        endSettle();
        press = { id: event.pointerId, x: event.clientX, scroll: track.scrollLeft };
        dragging = false;
        samples = [{ t: event.timeStamp, x: event.clientX }];
      };

      const onMove = (event) => {
        if (!press || event.pointerId !== press.id) return;
        const dx = event.clientX - press.x;
        if (!dragging) {
          if (Math.abs(dx) < DRAG_SLOP_PX) return;
          dragging = true;
          track.setPointerCapture(press.id);
          track.setAttribute('data-dragging', '');
        }
        track.scrollLeft = press.scroll - dx;
        samples.push({ t: event.timeStamp, x: event.clientX });
        if (samples.length > 5) samples.shift();
      };

      const onUp = (event) => {
        if (!press || event.pointerId !== press.id) return;
        press = null;
        if (!dragging) return;
        dragging = false;
        swallow = true;
        // The click, if one comes, is dispatched in this same task; a tick
        // later the flag must not survive into an unrelated click.
        window.setTimeout(() => {
          swallow = false;
        }, 0);

        const item = track.querySelector('[data-item]');
        if (!item) {
          endSettle();
          return;
        }
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        const page = item.getBoundingClientRect().width + gap;
        const count = track.children.length;
        const first = samples[0];
        const last = samples[samples.length - 1];
        // A drag that stopped before it was let go is a placement, not a
        // flick, however fast its last few moves were.
        const held = !last || event.timeStamp - last.t > FLICK_WINDOW_MS;
        const velocity = !held && first && last && last.t > first.t ? (last.x - first.x) / (last.t - first.t) : 0;
        const position = track.scrollLeft / page;
        // Dragging left (negative x) moves on to the NEXT picture.
        let target = Math.round(position);
        if (velocity < -FLICK_PX_PER_MS) target = Math.ceil(position);
        else if (velocity > FLICK_PX_PER_MS) target = Math.floor(position);
        target = Math.min(count - 1, Math.max(0, target));

        const left = Math.min(target * page, track.scrollWidth - track.clientWidth);
        if (Math.abs(left - track.scrollLeft) < 1) {
          endSettle();
          return;
        }
        track.addEventListener('scrollend', endSettle, { once: true });
        settleTimer = window.setTimeout(endSettle, SETTLE_FALLBACK_MS);
        track.scrollTo({ left, behavior: reduced() ? 'auto' : 'smooth' });
      };

      const onClick = (event) => {
        if (!swallow) return;
        swallow = false;
        event.preventDefault();
        // Immediate: under pointer capture the click can target the track
        // itself, where plain stopPropagation would not stop its other
        // listeners - the lightbox opener among them.
        event.stopImmediatePropagation();
      };

      // An <img> is natively draggable, and a mouse drag across one would pick
      // the picture up as a drag-and-drop ghost instead of moving the strip.
      const onDragStart = (event) => event.preventDefault();

      track.addEventListener('pointerdown', onDown);
      track.addEventListener('pointermove', onMove);
      track.addEventListener('pointerup', onUp);
      track.addEventListener('pointercancel', onUp);
      track.addEventListener('click', onClick, true);
      track.addEventListener('dragstart', onDragStart);

      return () => {
        endSettle();
        track.removeEventListener('pointerdown', onDown);
        track.removeEventListener('pointermove', onMove);
        track.removeEventListener('pointerup', onUp);
        track.removeEventListener('pointercancel', onUp);
        track.removeEventListener('click', onClick, true);
        track.removeEventListener('dragstart', onDragStart);
      };
    }

    class ProductGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.indicator = this.querySelector('[data-indicator]');
        this.thumb = this.querySelector('[data-thumb]');
        const track = this.track;
        if (!track) return;

        this.onUpdate = () => this.updateIndicator();
        track.addEventListener('scroll', this.onUpdate, { passive: true });
        this.releaseDrag = mouseDrag(track);
        this.releaseOpeners = this.bindOpeners(track);

        // Liquid renders every slide, so the count read below is already the
        // real one; this only catches a later change to the list. No
        // ResizeObserver: the step is a function of scrollLeft alone, and a
        // resize under scroll-snap keeps the slide.
        this.mutationObserver = new MutationObserver(this.onUpdate);
        this.mutationObserver.observe(track, { childList: true });

        // Count only. A gallery is connected on its first slide, where the
        // thumb already sits untransformed, so there is no position to write.
        this.count = 0;
        this.syncCount();
        this.step = 0;
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onUpdate);
        this.mutationObserver?.disconnect();
        this.releaseDrag?.();
        this.releaseOpeners?.();
      }

      // Every picture becomes the door to the lightbox. The button semantics
      // are written here rather than in Liquid, because a picture is only a
      // button while the script that makes it one is running; role + tabindex
      // rather than a <button> wrapper, so the slide keeps the image snippet's
      // box and the stylesheet written against it. The address is the one the
      // picture already loaded: the lightbox asks the CDN for its own widths
      // off it.
      bindOpeners(track) {
        const label = this.dataset.zoomLabel || '';
        for (const img of track.querySelectorAll('[data-item] img')) {
          img.setAttribute('role', 'button');
          img.tabIndex = 0;
          if (label) img.setAttribute('aria-label', label);
          img.dataset.zoomSrc = img.currentSrc || img.src;
        }

        const open = (img, touches) => {
          const index = [...track.querySelectorAll('img[data-zoom-src]')].indexOf(img);
          if (index < 0) return;
          document.dispatchEvent(
            new CustomEvent('product-gallery:open', {
              detail: { gallery: this, track, index, returnFocus: img, touches },
            }),
          );
        };
        const zoomableOf = (target) => (target instanceof Element ? target.closest('img[data-zoom-src]') : null);

        // click, not pointerup: the track is a scroll-snap carousel and a
        // swipe across it must stay a swipe. A click only survives a press
        // that did not travel, and mouseDrag swallows the one a drag ends in.
        const onClick = (event) => {
          const img = zoomableOf(event.target);
          if (img) open(img);
        };
        // Two fingers fire no click, and a pinch is the gesture buyers actually
        // use on a product photo. The picture's touch-action refuses the page
        // zoom (ADR 0045), so the lightbox opens on the second finger and the
        // pinch carries straight into it. Both fingers on the SAME picture: a
        // finger either side of a slide edge is a carousel gesture.
        const onTouchStart = (event) => {
          if (event.touches.length !== 2) return;
          const img = zoomableOf(event.touches[0]?.target);
          if (!img || img !== zoomableOf(event.touches[1]?.target)) return;
          open(img, event.touches);
        };
        const onKeyDown = (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          const img = zoomableOf(event.target);
          if (!img) return;
          // Space would scroll the page otherwise.
          event.preventDefault();
          open(img);
        };

        track.addEventListener('click', onClick);
        track.addEventListener('touchstart', onTouchStart, { passive: true });
        track.addEventListener('keydown', onKeyDown);
        return () => {
          track.removeEventListener('click', onClick);
          track.removeEventListener('touchstart', onTouchStart);
          track.removeEventListener('keydown', onKeyDown);
        };
      }

      // The thumb's width. A new count is PLACED rather than moved.
      syncCount() {
        const { track, indicator } = this;
        if (!track || !indicator) return;
        const count = track.children.length;
        if (count === this.count) return;
        this.count = count;
        indicator.style.setProperty('--product-gallery-count', String(Math.max(1, count)));
        this.step = -1;
      }

      // The thumb steps to the slide the scroll is nearest: it commits as soon
      // as the scroll passes halfway and eases there, rather than tracking the
      // finger or waiting for the scroll to end (app ADR 0054). Scroll events
      // and MutationObserver callbacks both run ahead of paint, so there is no
      // frame with the thumb at a stale width or place.
      updateIndicator() {
        const { track, thumb } = this;
        if (!track || !thumb) return;
        this.syncCount();
        const count = this.count;

        const maxScroll = track.scrollWidth - track.clientWidth;
        // Not laid out yet, or the desktop stack: nothing to position against.
        if (count < 2 || maxScroll <= 1) return;

        const progress = Math.min(1, Math.max(0, track.scrollLeft / maxScroll));
        const step = Math.round(progress * (count - 1));
        const place = this.step < 0;
        if (step === this.step) return;
        this.step = step;
        if (place) thumb.style.transition = 'none';
        thumb.style.transform = `translateX(${step * 100}%)`;
        if (place) {
          // Commit the jump before the transition comes back, so it is not
          // animated from the old value.
          thumb.getBoundingClientRect();
          thumb.style.transition = '';
        }
      }
    }

    if (!customElements.get('product-gallery')) {
      customElements.define('product-gallery', ProductGallery);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-list-layout"] && !Shopify.designMode) return;
  try {
    class ProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      if (!this.track) return;

      this.prevButton?.addEventListener('click', () => this.scrollByAmount(-1));
      this.nextButton?.addEventListener('click', () => this.scrollByAmount(1));
      this.track.addEventListener('scroll', () => this.updateNavState(), { passive: true });

      // Measured on every size change of the track rather than on window
      // resize: a carousel that connects inside a hidden box (the related
      // products shell) measures 0 x 0, and only the track growing tells it
      // there is something to scroll.
      this.resizeObserver = new ResizeObserver(() => this.updateNavState());
      this.resizeObserver.observe(this.track);

      this.updateNavState();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    scrollByAmount(direction) {
      const item = this.track.querySelector('[data-item]');
      if (!item) return;

      const gap = parseFloat(getComputedStyle(this.track).columnGap || '0');
      const amount = item.getBoundingClientRect().width + gap;
      this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    updateNavState() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const overflowing = maxScroll > 1;
      for (const button of [this.prevButton, this.nextButton]) {
        if (button) button.hidden = !overflowing;
      }
      if (this.prevButton) this.prevButton.disabled = this.track.scrollLeft <= 1;
      if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 1;
    }
  }

  if (!customElements.get('product-carousel')) {
    customElements.define('product-carousel', ProductCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-multipack"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const pill = event.target.closest('.product-multipack__pill');
    if (!pill || pill.hasAttribute('aria-current')) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    event.preventDefault();
    window.location.replace(pill.href);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-lock"] && !Shopify.designMode) return;
  try {
    (function () {
    // Native <dialog> reflects `open`; the mobile menu toggles it by hand;
    // data-slot dialogs set `data-open` on their content element instead.
    const SELECTOR = '[scroll-lock][open], [scroll-lock][data-open]';
    // Shared with the app block's copy of this module. Kept out of the
    // observer's attributeFilter below, so claiming it can't re-trigger a sync.
    const CLAIM = 'data-scroll-locked';

    if (!window.matchMedia('(pointer: coarse)').matches) return;

    let locked = false;
    let lockedScrollY = 0;
    let scheduled = false;

    function lock() {
      if (locked) return;
      // One page can carry two of these, and on the Stick Builder page it
      // does: the app block's takeover carries the same attribute pair, and
      // the block ships its own copy of this module, so both answer the same
      // mutation in the same frame. Whichever ran second read `window.scrollY`
      // AFTER the first had already taken the body out of flow - which
      // collapses the document's scrollable overflow and clamps the scroll to
      // 0 - so it wrote `top: -0px` over the right offset and the page behind
      // snapped to its top, in plain sight through the takeover's fade. On
      // close the same mismatch restored the buyer to scroll 0.
      //
      // Hence the claim: whoever gets there first marks the root and owns the
      // page until it releases. The other never sets `locked`, so its unlock()
      // is a no-op too and exactly one restore runs. Order-independent - it
      // does not matter which bundle parses first.
      if (document.documentElement.hasAttribute(CLAIM)) return;
      document.documentElement.setAttribute(CLAIM, '');
      locked = true;
      lockedScrollY = window.scrollY;

      // Pull-to-refresh rides on scroll chaining out of the page, and a fixed
      // body leaves nothing to scroll: every downward swipe the sheet does not
      // claim for itself reaches the viewport as overscroll, and Chrome on
      // Android answers that with a refresh - which throws away the sheet, the
      // filter selection, and the builder's in-progress stick. The swipe that
      // dismisses a sheet and the swipe that reloads the page are the same
      // swipe, so the page has to stop offering the second one.
      //
      // On the root element, not the body: Chrome propagates the viewport's
      // overscroll behaviour from html, and only from html since crbug.com/954423
      // - the recipes that say `body { overscroll-behavior-y: contain }`, Chrome's
      // own article included, predate that fix and no longer bite.
      //
      // `contain` rather than `none`: severing the chain is the whole job, and
      // `contain` keeps the boundary glow that tells the buyer their swipe
      // landed. The `-y` longhand rather than the shorthand, so nothing here
      // can reach the x axis, where a root-level block is what suppresses
      // edge-swipe back navigation.
      document.documentElement.style.overscrollBehaviorY = 'contain';

      const body = document.body;
      body.style.position = 'fixed';
      body.style.top = `-${lockedScrollY}px`;
      body.style.left = '0';
      // Not `width: 100%`: a fixed body's containing block is the viewport, so
      // insetting the body itself is what keeps the content width identical
      // across the lock. Always 0 on the touch devices this runs on - overlay
      // scrollbars occupy nothing, and critical.css's `scrollbar-gutter:
      // stable` is defined to reserve nothing where they are in use - but
      // correct is cheap, and this is the one place a real number could still
      // turn up (a coarse pointer on a classic-scrollbar desktop).
      body.style.right = `${window.innerWidth - document.documentElement.clientWidth}px`;
    }

    function unlock() {
      if (!locked) return;
      locked = false;
      document.documentElement.removeAttribute(CLAIM);

      // Ahead of the body reset, never between it and the scrollTo below.
      document.documentElement.style.overscrollBehaviorY = '';

      const body = document.body;
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      // Must stay synchronous with the reset above. In between the two the
      // document sits at scroll 0 with [data-scroll-sentinel] back at the top
      // of the viewport, which flips <sticky-header>'s data-sticky-state and
      // flashes the overlay header's transparent/solid transition. Nothing
      // may be inserted between these lines.
      window.scrollTo(0, lockedScrollY);
    }

    function sync() {
      scheduled = false;
      if (document.querySelector(SELECTOR)) lock();
      else unlock();
    }

    // Coalesced: the search drawer rewrites its results markup on every
    // keystroke, so childList mutations arrive in bursts and each one would
    // otherwise re-run the query.
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(sync);
    }

    new MutationObserver(schedule).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['open', 'data-open', 'scroll-lock'],
      // childList so an open overlay being removed outright - a theme-editor
      // section re-render, an AJAX swap - can't leave the page locked with
      // nothing on screen to close.
      childList: true,
      subtree: true,
    });

    sync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-drawer"] && !Shopify.designMode) return;
  try {
    const DEBOUNCE_MS = 250;
  const MIN_QUERY_LENGTH = 2;

  class SearchDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.input = this.querySelector('[data-search-input]');
      this.clearButton = this.querySelector('[data-search-clear]');
      this.results = this.querySelector('[data-search-results]');
      this.defaultPane = this.querySelector('[data-search-default]');
      this.status = this.querySelector('[data-search-status]');
      this.debounceTimer = null;
      this.abortController = null;
      this.options = [];
      this.activeIndex = -1;

      this.clearButton.hidden = this.input.value.length === 0;

      this.addEventListener('click', (event) => this.handleClick(event));
      this.input.addEventListener('input', () => this.handleInput());
      this.input.addEventListener('keydown', (event) => this.handleKeydown(event));
      this.form.addEventListener('submit', (event) => this.handleSubmit(event));
      this.dialog.addEventListener('close', () => this.clearActiveOption());
    }

    handleClick(event) {
      if (event.target.closest('[data-search-open]')) {
        this.open();
        return;
      }

      // event.target === this.dialog is the backdrop: the panel fills the
      // dialog's zero padding, so only a backdrop click lands on the dialog
      // element itself. Same trick as cart-drawer.liquid.
      if (event.target.closest('[data-search-close]') || event.target === this.dialog) {
        this.dialog.close();
        return;
      }

      if (event.target.closest('[data-search-clear]')) {
        this.clear();
      }
    }

    open() {
      this.dialog.showModal();
      // showModal() focuses the first focusable descendant, which is the
      // field icon's sibling only by accident of DOM order - be explicit.
      this.input.focus();
      this.input.select();
      // Announced rather than called: an inline theme JavaScript block cannot
      // import from src/, and the recently-viewed strip is filled by
      // src/recently-viewed.ts, which owns the store both drawers read. This
      // drawer used to own it, which is how the cart ended up depending on the
      // header's show_search setting to have any history at all.
      document.dispatchEvent(new CustomEvent('search:opened'));
    }

    handleInput() {
      const query = this.input.value.trim();
      this.clearButton.hidden = this.input.value.length === 0;
      clearTimeout(this.debounceTimer);

      if (query.length < MIN_QUERY_LENGTH) {
        this.abortController?.abort();
        this.abortController = null;
        this.showDefault();
        return;
      }

      this.debounceTimer = setTimeout(() => this.search(query), DEBOUNCE_MS);
    }

    async search(query) {
      this.abortController?.abort();
      const controller = new AbortController();
      this.abortController = controller;
      this.results.setAttribute('aria-busy', 'true');

      const url = new URL(this.dataset.predictiveUrl, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'query,product,collection,page,article');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('section_id', this.dataset.sectionId);

      try {
        const response = await fetch(url, { signal: controller.signal });
        // A 429 (the API throttles, with Retry-After) or any other failure
        // leaves the last good results on screen. There's no fallback
        // navigation to do here the way filtering has - submitting the form
        // is always still available.
        if (!response.ok) return;

        const html = await response.text();
        const section = new DOMParser()
          .parseFromString(html, 'text/html')
          .getElementById(`shopify-section-${this.dataset.sectionId}`);
        if (!section) return;

        this.showResults(section.innerHTML);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('search-drawer: predictive search failed', error);
        }
      } finally {
        // Only the newest request owns the busy state - an aborted one must
        // not clear it out from under its replacement.
        if (this.abortController === controller) {
          this.abortController = null;
          this.results.removeAttribute('aria-busy');
        }
      }
    }

    showResults(html) {
      this.results.innerHTML = html;
      this.results.hidden = false;
      this.defaultPane.hidden = true;

      this.options = [...this.results.querySelectorAll('[role="option"]')];
      this.activeIndex = -1;
      this.input.removeAttribute('aria-activedescendant');

      const listbox = this.results.querySelector('[role="listbox"]');
      this.input.setAttribute('aria-expanded', listbox ? 'true' : 'false');
      if (listbox) {
        this.input.setAttribute('aria-controls', listbox.id);
      } else {
        this.input.removeAttribute('aria-controls');
      }

      const statusText = this.results.querySelector('[data-search-status-text]');
      this.status.textContent = statusText ? statusText.textContent.trim() : '';
    }

    showDefault() {
      this.results.innerHTML = '';
      this.results.hidden = true;
      this.results.removeAttribute('aria-busy');
      this.defaultPane.hidden = false;
      this.status.textContent = '';
      this.clearActiveOption();
      this.input.setAttribute('aria-expanded', 'false');
      this.input.removeAttribute('aria-controls');
    }

    clear() {
      clearTimeout(this.debounceTimer);
      this.abortController?.abort();
      this.abortController = null;
      this.input.value = '';
      this.clearButton.hidden = true;
      this.showDefault();
      this.input.focus();
    }

    handleKeydown(event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (this.options.length === 0) return;
        event.preventDefault();

        const delta = event.key === 'ArrowDown' ? 1 : -1;
        let next;
        if (this.activeIndex === -1) {
          next = delta === 1 ? 0 : this.options.length - 1;
        } else {
          next = (this.activeIndex + delta + this.options.length) % this.options.length;
        }
        this.setActiveOption(next);
        return;
      }

      if (event.key === 'Enter') {
        const link = this.options[this.activeIndex]?.querySelector('a');
        if (link) {
          event.preventDefault();
          link.click();
        }
        return;
      }

      // Escape is handled explicitly rather than left to the platform,
      // because <input type="search"> already claims it: Chrome clears the
      // field itself and swallows the key, so the drawer would neither close
      // nor drop the now-stale results. One consistent rule instead - Escape
      // clears a non-empty field, and only closes the drawer once it's empty
      // (that second Escape falls through to the dialog).
      if (event.key === 'Escape' && this.input.value.length > 0) {
        event.preventDefault();
        this.clear();
      }
    }

    setActiveOption(index) {
      this.options.forEach((option, position) => {
        option.setAttribute('aria-selected', String(position === index));
      });

      this.activeIndex = index;
      const option = this.options[index];
      if (!option) return;

      this.input.setAttribute('aria-activedescendant', option.id);
      option.scrollIntoView({ block: 'nearest' });
    }

    clearActiveOption() {
      this.options.forEach((option) => option.setAttribute('aria-selected', 'false'));
      this.activeIndex = -1;
      this.input.removeAttribute('aria-activedescendant');
    }

    handleSubmit(event) {
      if (this.input.value.trim().length === 0) event.preventDefault();
    }
  }

  if (!customElements.get('search-drawer')) {
    customElements.define('search-drawer', SearchDrawer);
  }
  } catch(e) { console.error(e); }
})();

})();
